import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { FileText } from 'lucide-react';
import { GoogleOAuthButton, AuthDivider, AuthFormField, AuthSubmitButton, AuthError } from '@/components/AuthComponents';

export default function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await login(email, password);
    setLoading(false);
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <FileText className="w-12 h-12 text-[#FB923C]" strokeWidth={2} />
          </div>
          <h1 className="text-4xl font-black text-slate-900 mb-2" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }} data-testid="login-heading">
            Welcome back
          </h1>
          <p className="text-base text-slate-600" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
            Log in to continue building your resume
          </p>
        </div>

        <div className="bg-white border border-slate-200 p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <AuthError error={error} testId="login-error" />
            <AuthFormField id="email" label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" testId="login-email-input" required />
            <AuthFormField id="password" label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" testId="login-password-input" required />
            <AuthSubmitButton loading={loading} loadingText="Logging in..." text="Log In" testId="login-submit-btn" />
          </form>

          <AuthDivider />
          <GoogleOAuthButton label="Continue with Google" />

          <div className="mt-6 text-center">
            <p className="text-sm text-slate-600">
              Don't have an account?{' '}
              <Link data-testid="login-signup-link" to="/register" className="font-bold text-[#FB923C] hover:text-orange-600">Sign up</Link>
            </p>
          </div>
        </div>

        <div className="mt-6 text-center">
          <Link data-testid="login-back-link" to="/" className="text-sm text-slate-600 hover:text-slate-900">← Back to home</Link>
        </div>
      </div>
    </div>
  );
}
